// api.js
export default {
    async addToCart(data) {
        try {
            const response = await axios.post(`cart_items`, data);

            // Return response data if needed
            return response.data;
        } catch (error) {
            throw new Error('Failed to add to cart');
        }
    },
    async removeFromCart(cart) {
        try {
            const response = await axios.delete(`cart_items/${cart.id}`);

            // Return response data if needed
            return response.data;
        } catch (error) {
            throw new Error('Failed to remove from cart');
        }
    },
};
